import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  colors: {
    // Modern nötr gri palet ve hafif marka vurgusu
    brand: {
      50: '#F5F7FA',
      100: '#E4E7EB',
      200: '#CBD2D9',
      300: '#9AA5B1',
      400: '#7B8794',
      500: '#616E7C',
      600: '#52606D',
      700: '#3E4C59',
      800: '#323F4B',
      900: '#1F2933',
    },
    gray: {
      50: '#F8FAFC',
      100: '#F1F5F9',
      200: '#E2E8F0',
      300: '#CBD5E1',
      400: '#94A3B8',
      500: '#64748B',
      600: '#475569',
      700: '#334155',
      800: '#1E293B',
      900: '#0F172A',
    },
    blue: {
      500: '#3B82F6',
      600: '#2563EB',
    },
  },
  fonts: {
    heading: "'Inter', sans-serif",
    body: "'Inter', sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: 'gray.50',
        color: 'gray.800',
        fontSize: 'sm',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: 'sm',
        fontWeight: 'medium',
        textTransform: 'none',
        _focusVisible: {
          boxShadow: '0 0 0 2px var(--chakra-colors-blue-500)',
        },
      },
      sizes: {
        md: { px: 4, py: 2 },
        sm: { px: 3, py: 1.5, fontSize: 'sm' },
      },
      variants: {
        solid: {
          bg: 'brand.700',
          color: 'white',
          _hover: { bg: 'brand.800' },
          _active: { bg: 'brand.900' },
          _disabled: { bg: 'gray.200', color: 'gray.400' },
        },
        outline: {
          borderColor: 'gray.300',
          color: 'gray.700',
          _hover: { bg: 'gray.100' },
        },
        ghost: {
          color: 'gray.700',
          _hover: { bg: 'gray.100' },
        },
      },
      defaultProps: {
        colorScheme: 'brand',
      },
    },
    Input: {
      variants: {
        outline: {
          field: {
            borderWidth: '1px',
            borderColor: 'gray.300',
            bg: 'white',
            color: 'gray.800',
            _placeholder: { color: 'gray.400' },
            _hover: { borderColor: 'gray.400' },
            _focus: {
              borderColor: 'blue.600',
              boxShadow: '0 0 0 1px var(--chakra-colors-blue-600)',
            },
          },
        },
      },
      defaultProps: {
        variant: 'outline',
        size: 'sm',
      },
    },
    Textarea: {
      variants: {
        outline: {
          borderWidth: '1px',
          borderColor: 'gray.300',
          bg: 'white',
          color: 'gray.800',
          _placeholder: { color: 'gray.400' },
          _hover: { borderColor: 'gray.400' },
          _focus: {
            borderColor: 'blue.600',
            boxShadow: '0 0 0 1px var(--chakra-colors-blue-600)',
          },
        },
      },
      defaultProps: {
        variant: 'outline',
        size: 'sm',
      },
    },
    Select: {
      variants: {
        outline: {
          field: {
            borderWidth: '1px',
            borderColor: 'gray.300',
            bg: 'white',
            color: 'gray.800',
            _hover: { borderColor: 'gray.400' },
            _focus: {
              borderColor: 'blue.600',
              boxShadow: '0 0 0 1px var(--chakra-colors-blue-600)',
            },
          },
        },
      },
      defaultProps: {
        variant: 'outline',
        size: 'sm',
      },
    },
    FormLabel: {
      baseStyle: {
        textTransform: 'none',
        fontWeight: 'medium',
      },
    },
    Text: {
      baseStyle: {
        textTransform: 'none',
      },
    },
    Heading: {
      baseStyle: {
        textTransform: 'none',
      },
    },
    Table: {
      parts: ['th', 'thead'],
      baseStyle: {
        th: {
          textTransform: 'none',
          fontWeight: 'semibold',
        },
      },
      variants: {
        simple: {
          th: {
            textTransform: 'none',
          },
        },
      },
    },
    Badge: {
      baseStyle: {
        textTransform: 'none',
      },
    },
  },
});

export default theme;
